import React from 'react'

type PropsType = {
  //
}

export const Divider: React.FC<PropsType> = () => (
  <div className="account-menu__divider" />
)
